import React, { useEffect, useState } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router";
import { moveToTop } from "../../helpers/DomHelper";
import { observer } from "mobx-react";
import menuStore from "../../stores/menu";
import { ArticleViewType } from "../../@types/enums/ArticleViewType";
import RecommendationGroup from "./RecommendationGroup";


const Recommendations = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [searchParams] = useSearchParams();

    const [groups, setGroups] = useState<number[]>([]);
    const [groupId, setGroupId] = useState<number | undefined>();

    useEffect(() => {
        moveToTop();
        init();
    }, [location]);

    const init = () => {
        menuStore.changeRecommendationItem();
        if (menuStore.navigation.item) {
            const item = menuStore.getItemById(menuStore.navigation.item);

            // Article recommendations
            if (item?.recommendedGroups?.length) {
                if (menuStore.recommendations?.filter(g => item.recommendedGroups?.indexOf(g.id) !== -1)?.length) {
                    menuStore.changeRecommendationGroup(-1);
                    setGroups(item.recommendedGroups);
                    setGroupId(params.groupId ? +params.groupId || undefined : item.recommendedGroups.at(0));

                    return;
                }
            }
            // Combo recommendations
            else {
                const combination = menuStore.getCombinationById(menuStore.navigation.item);
                if (combination && menuStore.navigation.combinationRecommendationGroupIds?.length) {
                    if (menuStore.recommendations?.filter(g => menuStore.navigation.combinationRecommendationGroupIds?.indexOf(g.id) !== -1)?.length) {
                        menuStore.changeRecommendationGroup(-1);
                        setGroups(menuStore.navigation.combinationRecommendationGroupIds);
                        setGroupId(params.groupId ? +params.groupId || undefined : menuStore.navigation.combinationRecommendationGroupIds.at(0));

                        return;
                    }
                }
            }
        }

        navigate("/menu");
    }

    const goToMenu = () => {
        navigate("/menu");
    }

    const goToOrder = () => {
        navigate("/order");
    }

    const goNext = () => {
        const isLast = groups.at(-1) === groupId;
        if (isLast) {
            goToMenu();
        }
        else {
            const nextGroupId = groups.at(groups.findIndex(x => x === groupId) + 1);
            navigate(`/recommendations/${nextGroupId}`);
        }
    }

    if (!groups.length) return null;
    if ((localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE || localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE) && groupId === undefined) return null;

    return <div className="Recommendations">
        <h2>{t("weRecommend")}</h2>
        {!localStorage.getItem("articleViewType") || localStorage.getItem("articleViewType") === ArticleViewType.ONE_PAGE
            ? menuStore.recommendations?.filter(g => groups.indexOf(g.id) !== -1).map(g => <RecommendationGroup key={`recommendation_group_${g.id}`} group={g} />)
            : null
        }
        {localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE || localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE
            ? menuStore.recommendations?.filter(g => g.id === groupId).map(g => <RecommendationGroup key={`recommendation_group_${g.id}`} group={g} />)
            : null
        }

        {!localStorage.getItem("articleViewType") || localStorage.getItem("articleViewType") === ArticleViewType.ONE_PAGE
            ? <div className="button dark" onClick={() => { searchParams.get("toOrder") === "true" ? goToOrder() : goToMenu() }}>
                {t("noThanks")}
            </div>
            : null
        }

        {localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE || localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE
            ? <div className="button dark" onClick={goNext}>
                {t("next")}
            </div>
            : null
        }
    </div>
}

export default observer(Recommendations);
